import { render } from "./CrmPrivilegeCard.vue?vue&type=template&id=3fdeac43&scoped=true"
import script from "./CrmPrivilegeCard.vue?vue&type=script&lang=js"
export * from "./CrmPrivilegeCard.vue?vue&type=script&lang=js"

import "./CrmPrivilegeCard.vue?vue&type=style&index=0&id=3fdeac43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdeac43"]])

export default __exports__